import React from "react";
import { Link } from "react-router-dom";

import { CourseCard, Title } from "..";

import { courses } from "../../assets/data/data";

const Courses = () => {
  return (
    <section className="courses my-3">
      <div className="container">
        <Title title="Our Courses" subtitle="Find the right course for you" />
        <div className="row">
          {courses
            .filter((item) => item.category === "web" || item.category === "kids" || item.category === "d_m")
            .slice(0, 6)
            .map((item) => (
              <CourseCard {...item} key={item.id} />
            ))}
        </div>
        <div className="row">
          <div className="col-12 text-center mt-3">
            <Link to="/courses" className="theme-btn">
              view all courses
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Courses;
